import { render, staticRenderFns } from "./WordCloudNew.vue?vue&type=template&id=72363b5c&scoped=true&"
import script from "./WordCloudNew.vue?vue&type=script&lang=js&"
export * from "./WordCloudNew.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudNew.vue?vue&type=style&index=0&id=72363b5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72363b5c",
  null
  
)

export default component.exports